import { NgModule } from '@angular/core';

import zhCN from './languages/zh-CN';

import { OHAYO_LOCALE_SERVICE_PROVIDER } from './locale.service';
import { OHAYO_LOCALE } from './locale.tokens';

@NgModule({
  providers: [{ provide: OHAYO_LOCALE, useValue: zhCN }, OHAYO_LOCALE_SERVICE_PROVIDER],
})
export class OhayoLocaleModule {}
